import React from 'react'
import '../styles/ticker.scss'

import { Link } from 'gatsby'

// Shout out to https://codepen.io/lewismcarey/pen/GJZVoG for this

const Ticker = () => {
    
    return (
        <div className="ticker-wrap">
            <div className="ticker">
                <Link to="/merch" className="ticker__item">
                    Now Live: Shop New Black Elite merch on the online store
                </Link>
                <Link to="/listen" className="ticker__item">
                    Listen to New Black Elite album
                </Link>
                <Link to="/merch" className="ticker__item">
                    Now Live: Shop New Black Elite merch on the online store
                </Link>
            </div>
        </div>
    )
}

export default Ticker
